import type { RouteObject } from 'react-router-dom';

/**
 * Views 7 (list), 8 (detail) and 9 (issuing).
 *
 * `dtes/new` (the family chooser) and `dtes/new/:family` (one family's form)
 * go BEFORE `dtes/:id`: react-router tries the routes in order and, with
 * `:id` first, "new" would parse as an id.
 */
export const dtesRoutes: RouteObject[] = [
  {
    path: 'dtes',
    lazy: () =>
      import('../pages/DtesListPage').then((m) => ({
        Component: m.DtesListPage,
      })),
  },
  {
    path: 'dtes/new',
    lazy: () =>
      import('../pages/DteCreatePage').then((m) => ({
        Component: m.DteCreatePage,
      })),
  },
  {
    path: 'dtes/new/:family',
    lazy: () =>
      import('../pages/DteCreatePage').then((m) => ({
        Component: m.DteCreatePage,
      })),
  },
  {
    path: 'dtes/:id',
    lazy: () =>
      import('../pages/DteDetailPage').then((m) => ({
        Component: m.DteDetailPage,
      })),
  },
];
